import { TimeLogApi, ToastStateHandler } from '../../../api';
import { SubmitTimelogDto } from '../../../commonTypes/timelog.types';
import { dispatch } from '../../../store';
import { addSubmissionIntervalOfProject } from '../../../store/slices/time-tracking.slice';
import { useContainer } from '../../useContainer';
import { useTranslation } from '../../useTranslation';

const useHttpSubmitTimelogs = () => {
    const { t } = useTranslation('newNotifications');
    const timeLogApi: TimeLogApi = useContainer(TimeLogApi);
    const toastHandler: ToastStateHandler = useContainer(ToastStateHandler);

    const exec = (body: SubmitTimelogDto) => {
        const { exec, abort } = timeLogApi.submitTimelog({
            body,
            onSuccess: res => {
                dispatch(addSubmissionIntervalOfProject(res.body));
                toastHandler.push('success', t('timelog.timesheetSubmissionTitle'), t('timelog.timesheetSubmissionSuccess'));
            },
            onError: error => {
                if (error.includes('overlapping'))
                    return toastHandler.push('warn', t('timelog.timesheetSubmissionTitle'), t('timelog.timesheetSubmissionOverlapingIntervals'));
                if (error.includes(`don't have time logs to submit`))
                    return toastHandler.push('warn', t('timelog.timesheetSubmissionTitle'), t('timelog.timesheetSubmissionNoTimeLogsInInterval'));
                if (error.includes('not all time logs are finished'))
                    return toastHandler.push('warn', t('timelog.timesheetSubmissionTitle'), t('timelog.timesheetSubmissionUnfinishedTimelogs'));
            },
        });
        exec();
        return abort;
    };

    return { exec };
};

export default useHttpSubmitTimelogs;
